import TouchAppIcon from '@material-ui/icons/TouchApp';

import PERMISSIONS from 'Authorized/PERMISSIONS';

import { ILinkConfig } from 'types';

export const Links: Array<ILinkConfig> = [
	{
		text: 'Manual KYC',
		Icon: TouchAppIcon,
		permission: [
			PERMISSIONS.CAN_VIEW_MANUAL_KYC_ADMIN,
			PERMISSIONS.CAN_VIEW_MANUAL_KYC,
			PERMISSIONS.CAN_VIEW_MANUAL_KYC_QA,
			PERMISSIONS.CAN_VIEW_SHOP_VALIDATOR,
			PERMISSIONS.CAN_VIEW_SHOP_VALIDATOR_ADMIN,
		],
		sublist: [
			{
				text: 'KYC Admin',
				href: '/merchantkyc/manual-kyc/admin',
				permission: [PERMISSIONS.CAN_VIEW_MANUAL_KYC_ADMIN, PERMISSIONS.CAN_VIEW_SHOP_VALIDATOR_ADMIN],
			},
			{
				text: 'KYC View',
				href: '/merchantkyc/manual-kyc',
				permission: [
					PERMISSIONS.CAN_VIEW_MANUAL_KYC_ADMIN,
					PERMISSIONS.CAN_VIEW_MANUAL_KYC,
					PERMISSIONS.CAN_VIEW_MANUAL_KYC_QA,
					PERMISSIONS.CAN_VIEW_SHOP_VALIDATOR,
					PERMISSIONS.CAN_VIEW_SHOP_VALIDATOR_ADMIN,
				],
			},
		],
	},
];
